import React from 'react'
import {ReactComponent as BackIcon} from 'assets/images/icons/arrow-left-circle.svg'
import GlotioIconButton from 'components/GlotioComponents/GlotioIconButton'
import styles from './index.module.scss'

const BackButton = ({ pushBack, ...rest }) => <GlotioIconButton className={styles.back_button} size='small' onClick={pushBack} icon={<BackIcon />} {...rest} />

export default BackButton
